import { render, staticRenderFns } from "./ShowReview.vue?vue&type=template&id=4c4c8408&scoped=true"
import script from "./ShowReview.vue?vue&type=script&lang=js"
export * from "./ShowReview.vue?vue&type=script&lang=js"
import style0 from "./ShowReview.vue?vue&type=style&index=0&id=4c4c8408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c8408",
  null
  
)

export default component.exports